<template>
  <div>
    <v-dialog
      @keydown.esc="isOpen=false"
      persistent
      v-model="isOpen"
      width="416">
      <v-card>
        <div class="d-flex justify-end">
          <v-btn
            fab
            color="transparent"
            small
            depressed
            @click="closeDialog()"
            class="mr-1 mt-1"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="pt-0 px-8 title">
          {{ $t('expenses.outgoingCategories.typeDialog.title') }}
        </v-card-title>
        <v-card-text class="px-8 pb-8">
          <div class="d-flex justify-end mb-2">
            <Button size="x-small" @click="openEditDialog()">
              <v-icon>mdi-plus</v-icon>
              <span>{{ $t('expenses.outgoingCategories.typeDialog.buttonCreate') }}</span>
            </Button>
          </div>
          <div>
            <v-data-table
              v-if="table.outgoingTypes.data.length"
              :loading-text="table.outgoingTypes.loadingText"
              :loading="table.outgoingTypes.loading"
              :headers="table.outgoingTypes.headers"
              :items="table.outgoingTypes.data"
              :options="table.outgoingTypes.options"
              hide-default-footer
              sort-by="name"
              class="table"
            >
              <template v-slot:[`item.name`]="{ item }">
                <div>{{ item.name }}</div>
              </template>
              <template v-slot:[`item.isExpense`]="{ item }">
                <div>{{ item.isExpense ? 'Gasto' : 'Gasto fuera' }}</div>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <div class="d-flex justify-end">
                  <v-btn
                    fab
                    color="primary"
                    x-small
                    depressed
                    @click="openEditDialog({
                      _id: item._id,
                      name: item.name
                    })"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      @keydown.esc="editDialogOpen=false"
      persistent
      v-model="editDialogOpen"
      width="416">
      <v-card>
        <div class="d-flex justify-end">
          <v-btn
            fab
            color="transparent"
            small
            depressed
            @click="closeEditDialog()"
            class="mr-1 mt-1"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="pt-0 px-8 pb-6 title">
           {{ this.form._id ? $t('expenses.outgoingCategories.editTypeDialog.editTitle') : $t('expenses.outgoingCategories.editTypeDialog.createTitle') }}
        </v-card-title>
        <v-card-text class="px-8">
          <v-form v-model="isValid" ref="form">
            <v-row>
              <v-col>
                <v-text-field
                  rounded
                  outlined
                  dense
                  v-model="form.name"
                  :rules="rules.required"
                  :label="$t('expenses.outgoingCategories.editTypeDialog.name')"
                  append-icon="mdi-pencil-outline"
                  class="outlinedInput"
                />
              </v-col>
              <v-col class="py-0" cols="12">
                <v-switch label="Es Gasto" v-model="form.isExpense"/>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between px-10 pb-8">
          <Button size="x-small" type="outlined" @click="closeEditDialog()">
            {{ $t('expenses.outgoingCategories.editTypeDialog.buttonCancel') }}
          </Button>
          <Button size="x-small" @click="create()">
            {{ this.form._id ? $t('expenses.outgoingCategories.editTypeDialog.buttonEdit') : $t('expenses.outgoingCategories.editTypeDialog.buttonCreate') }}
          </Button>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Button from '@/components/elements/Button'

export default {
  components: {
    Button
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      editDialogOpen: false,
      isValid: false,
      form: {
        name: null,
        isExpense: false
      },
      rules: {
        required: [v => !!v || `Este campo ${this.$i18n.t('messages.isRequired')}`]
      },
      table: {
        outgoingTypes: {
          loadingText: this.$i18n.t('expenses.outgoingCategories.typeDialog.table.loadingText'),
          loading: false,
          headers: [
            { text: this.$i18n.t('expenses.outgoingCategories.typeDialog.table.headers.name'), value: 'name' },
            { text: '', value: 'isExpense' },
            { text: '', value: 'action' }
          ],
          data: [],
          total: 0,
          options: {
            groupBy: [],
            groupDesc: [],
            itemsPerPage: 50,
            multiSort: false,
            mustSort: false,
            page: 1,
            sortBy: [''],
            sortDesc: []
          }
        }
      }
    }
  },
  watch: {
    isOpen: async function (val) {
      if (val) {
        await this.loadTypes()
      }
    }
  },
  methods: {
    openDialog () {
      this.isOpen = true
    },
    openEditDialog (type) {
      if (type) {
        this.form = { ...type }
      }
      this.editDialogOpen = true
    },
    closeDialog () {
      this.isOpen = false
      this.table.outgoingTypes.data = []
    },
    closeEditDialog () {
      this.editDialogOpen = false
      this.form = {
        name: null
      }
      this.$refs.form.resetValidation()
    },
    async create () {
      this.$refs.form.validate()
      if (this.isValid) {
        this.overlay = true
        try {
          const payload = {
            ...this.form,
            kind: 'outgoing',
            restaurant: this.$store.state.currentRestaurant.data._id
          }
          if (this.form._id) {
            await this.$api.put(`/v1/cashflows/types/${this.form._id}`, payload)
          } else {
            await this.$api.post(`/v1/cashflows/types`, payload)
          }
          this.loadTypes()
          this.$emit('updated')
          this.closeEditDialog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    async loadTypes (params = null) {
      params = params || {
        kind: 'outgoing',
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      this.table.outgoingTypes.loading = true
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/cashflows/types`, params)
        this.table.outgoingTypes.data = response.data
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.outgoingTypes.loading = false
      this.overlay = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .title {
    font-weight: 500;
    font-size: 22px;
    color: #01D28E;
  }

  .outlinedInput {
    & ::v-deep .v-label {
      top: auto;

      &--active {
        top: 10px !important;
      }
    }

    & ::v-deep .v-input__slot {
      padding-right: 8px !important;
    }

    & ::v-deep .v-input__append-inner {
      margin-top: 4px !important;
    }

    & ::v-deep .v-input__icon--append {
      color: #01D28E;
    }
  }
</style>

<style lang="scss">
  .table {
    overflow-y: auto;
    max-height: 65vh;
  }

  .table tr {
    border: 1px solid #ACABAB;
    border-radius: 7px;
  }

  .table td:first-child {
    border-left: 1px solid #ACABAB;
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;
  }

  .table td {
    border-top: 1px solid #ACABAB;
    border-bottom: 1px solid #ACABAB;
  }

  .table td:last-child {
    border-right: 1px solid #ACABAB;
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
  }

  .table thead tr:last-child th {
    border-bottom: none !important;
  }
</style>
